import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { CanonicalService } from '../../shared/canonical.service';


@Component({
  selector: 'app-partners',
  templateUrl: './partners.component.html',
  styleUrls: ['./partners.component.css']
})
export class PartnersComponent implements OnInit {

  heading = "Our Prestigious Partners";
  subheading = "";
  innerWidth:number = window.innerWidth;
  partnerImgWidth:string = '254px';

  slide1Config = {"slidesToShow": 4, "slidesToScroll": 1,"autoplay": true, "autoplaySpeed": 1500, "arrows":false, "dots":false, "infinite":true,
  responsive: [{
    breakpoint: 1024,
    settings: {
      slidesToShow: 4,
      slidesToScroll: 1,
      // centerMode: true,
    }

  }, {
    breakpoint: 992,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 1,
      dots: false,
      infinite: true,
      arrows: false,
    }
  },{
    breakpoint: 767,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 1,
      dots: false,
      infinite: true,
      arrows: false,
    }
  },  {
    breakpoint: 480,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 2000,
      arrows: false,
    }
  }]
  };

  slides1 = [
    {img: "assets/images/partners/network.webp"},
    {img: "assets/images/partners/NanjgelHiResTrans.webp"},
    {img: "assets/images/partners/Orbit.webp"},
    {img: "assets/images/partners/MindGate.webp"},
    {img: "assets/images/partners/insight.webp"},
    {img: "assets/images/partners/aws.webp"},
    {img: "assets/images/partners/sisl.webp"},
    {img: "assets/images/partners/wysetek.webp"},
    {img: "assets/images/partners/softcell.webp"},
  ];

  addSlide1() {
    this.slides1.push({img: "http://placehold.it/350x150/777777"})
  }

  removeSlide1() {
    this.slides1.length = this.slides1.length - 1;
  }

  slick1Init() {
  }

  breakpoint1() {
  }

  afterChange1() {
  }

  beforeChange1() {
  }

  constructor(private titleService: Title, private metaTagService: Meta, private canonicalService: CanonicalService) {
    this.canonicalService.setCanonicalURL("https://www.protectt.ai/partners");
   }

  ngOnInit(): void {
    this.titleService.setTitle('Our Product Partners | Mobile App Security | Protectt.ai');
    this.metaTagService.updateTag(
      { name: 'description', content: 'Know more about our Product Partners. Get Mobile App Security, Mobile Privacy Guard, Realtime Payment Security, RASP, Smartphone Antivirus, Cyber Lab.' }
    );
  }
  onResize(event:any){
    this.innerWidth = event.target.innerWidth;
  }

}
